import './jumbotron-sidekick.scss';

import { cn } from '@sola/ark-core/utils/helpers.js';
import { FlexibleContentProps } from '@sola/schema/lib/schema.js';
import { getHeaderDisplayLevel } from '@sola/utils/assembly.js';

import { FeatureCard } from '../../../molecules/feature-card/feature-card';
import { getBaseSizeProps } from '../../../utils/text-utils';

export const JumbotronSidekick: React.FC<FlexibleContentProps> = ({
  seoLevel = 2,
  inline,
  alt,
  items: _items,
  ...props
}) => {
  const imagePlacement = alt ? 'right' : 'left';

  const headerDisplayLevel = getHeaderDisplayLevel(seoLevel);

  return (
    <section
      className={cn('JumbotronSidekick component--container', {
        'JumbotronSidekick--alt': alt,
        component: !inline,
      })}
    >
      <div
        className={cn('JumbotronSidekick__container', {
          container: !inline,
        })}
      >
        <FeatureCard
          {...props}
          {...getBaseSizeProps(headerDisplayLevel)}
          seoLevel={seoLevel}
          titleSize={seoLevel === 1 ? 'lg' : 'md'}
          imagePlacement={imagePlacement}
          variant="horizontal"
          buttonVariant="grow"
          hasPlaceholder
        />
      </div>
    </section>
  );
};
